import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class TenderTypesPublicationPurposeComponent extends CommonTab {
    state = {
        tenderPublicationPurpose: this.props.tenderPublicationPurpose,
        errors: [],
        validateFields: [
            'tenderpublicationpurposename',
            'tenderpublicationpurposenameeng'
        ]
    };


    changeState(name, e) {
        let temp = this.state.tenderPublicationPurpose;
        temp[name] = e.value;
        this.setState({tenderPublicationPurpose: temp});
    }

    render() {
        let {tenderPublicationPurpose, errors, validateFields} = this.state;
        let {close} = this.props;
        return (
            <Popup openClose={close}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        this.formValidation(tenderPublicationPurpose, validateFields);
                    }}>
                        <h2>{this.props.button} Tender Publication Purpose</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Tender Publication Purpose Name :</td>
                                <td className={errors.indexOf('tenderpublicationpurposename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPublicationPurpose.tenderpublicationpurposename}
                                        onChange={(e) => {
                                            this.changeState('tenderpublicationpurposename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpublicationpurposename') !== -1 ? <span className="errorText">Please set Tender Publication Purpose Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Tender Publication Purpose Name Eng :</td>
                                <td className={errors.indexOf('tenderpublicationpurposenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPublicationPurpose.tenderpublicationpurposenameeng}
                                        onChange={(e) => {
                                            this.changeState('tenderpublicationpurposenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpublicationpurposenameeng') !== -1 ? <span className="errorText">Please set Tender Publication Purpose Name Eng</span> : '' }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.tenderPublicationPurpose.map((item) => {
        if (item.tenderpublicationpurposeid == ownProps.id) {
            content = item;
        }
    });
    return {
        tenderPublicationPurpose: Object.assign({}, content)
    }
};

const TenderTypesPublicationPurpose = connect(mapStateToProps)(TenderTypesPublicationPurposeComponent);

export default TenderTypesPublicationPurpose;